import React from 'react'
import { Card, Spinner, NonIdealState } from '@blueprintjs/core'

/**
 * GeneralInformationCard component renders general segmentation information.
 * @param {Object} props - The component props.
 * @param {string} props.algo - Algorithm name.
 * @param {number} props.size - Number of segments.
 * @param {number} props.silhouette_score - Average silhouette score.
 * @param {Array} props.inputs - Array of input objects.
 * @param {number} props.seed - Random seed used for segmentation.
 * @param {boolean} props.is_imported - Flag indicating if segmentation was imported.
 * @param {string|number} props.id - Unique identifier for the segmentation.
 * @param {boolean} props.isLoading - Whether the data is currently loading.
 */
export function GeneralInformationCard({
  algo,
  size,
  silhouette_score,
  inputs,
  seed,
  is_imported,
  id,
  nmf_runs,
  snmf_balance_tolerance,
  isLoading,
}) {
  return (
    <Card className="segmentation-explorer-general-information-card">
      <h3>General Information</h3>
      {isLoading ? (
        <NonIdealState icon={<Spinner intent="primary" />} title="Loading..." />
      ) : (
        <>
          <p>
            <strong>Algorithm:</strong> {is_imported ? 'Imported' : algo}
          </p>
          <p>
            <strong>Segments:</strong> {size}
          </p>
          {!is_imported && (
            <p>
              <strong>Avg. Silhouette Score:</strong>{' '}
              {silhouette_score != null ? silhouette_score.toFixed(3) : 'N/A'}
            </p>
          )}
          <p>
            <strong>Inputs:</strong> {inputs.length}
          </p>
          {!is_imported && (
            <p>
              <strong>Seed:</strong> {seed}
            </p>
          )}
          <p>
            <strong>Is imported:</strong> {is_imported ? 'Yes' : 'No'}
          </p>
          <p>
            <strong>Solution ID:</strong> {id}
          </p>
          {!is_imported && algo == 'NMF' && (
            <p>
              <strong>Number of runs:</strong> {nmf_runs}
            </p>
          )}
          {!is_imported && algo == 'SNMF' && (
            <p>
              <strong>Balance tolerance:</strong>{' '}
              {snmf_balance_tolerance != null
                ? `${(snmf_balance_tolerance * 100).toFixed(2)}%`
                : 'N/A'}
            </p>
          )}
        </>
      )}
    </Card>
  )
}
